import {
    calendarEventPrivateIconTitle,
    calendarEventAttachmentIconTitle,
    calendarEventRecurringIconTitle,
    calendarEventRecurringIconExceptionTitle,
} from './getCalendarEventIcon.locstring.json';
import loc from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';
import type { IIconProps } from '@fluentui/react/lib/Icon';
import { assertNever } from 'owa-assert';

type EventIconType = 'Private' | 'HasAttachments' | 'Recurring' | 'RecurringException';

export function getCalendarEventIcon(eventDetails: EventIconType): IIconProps {
    switch (eventDetails) {
        case 'Private':
            return {
                iconName: ControlIcons.Lock,
                title: loc(calendarEventPrivateIconTitle),
            };
        case 'HasAttachments':
            return {
                iconName: ControlIcons.Attach,
                title: loc(calendarEventAttachmentIconTitle),
            };
        case 'Recurring':
            return {
                iconName: ControlIcons.SyncOccurence,
                title: loc(calendarEventRecurringIconTitle),
            };
        case 'RecurringException':
            return {
                iconName: ControlIcons.UnsyncOccurence,
                title: loc(calendarEventRecurringIconExceptionTitle),
            };
        default:
            return assertNever(eventDetails);
    }
}
